import axiosInstance from '../_helpers/axiosConfig'
import { authHeader } from '../_helpers/auth-header'

export const vaccineScheduleService = {
  all,
  slots,
  create
};

function slots(scheduleId, page) {
  return axiosInstance.request({
    method: 'GET',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/vaccine/schedule/${scheduleId}/slot?page=${page}`,
  }).then(response => response.data);
}

function all() {
  return axiosInstance.request({
    method: 'GET',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/vaccine/schedule`,
  }).then(response => response.data.data);
}

function create(data) {
  return axiosInstance.request({
    method: 'POST',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/vaccine/schedule`,
    data: data
  }).then(response => response.data.data);
}